import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { Drawer, TextField, Button, Box, IconButton, Grid, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InputField from "../../components/InputField";
import { t } from "i18next";
import styles from "./styles";
import CustomSelect from "../../components/SelectField";
import { ClientStatus } from "./types";
import { useTranslation } from "react-i18next";

type FilterInputs = {
    name: string;
    email: string;
    phone: string;
    companyTaxId: string;
    address: string;
    postalCode: string;
    status: string;
};



type FilterDrawerProps = {
    drawerOpen: boolean;
    toggleDrawer: (open: boolean) => () => void;
    handleApplyFilters: (filters: FilterInputs) => void;
};

const defaultValues = {
    name: "",
    companyTaxId: "",
    email: "",
    phone: "",
    postalCode:"",
    address: "",
    status: ""
};


const clientStatusList = Object.entries(ClientStatus).map((rec) => ({
    name: rec[0],
    value: rec[1],
  }));



const FilterDrawer = ({ drawerOpen, toggleDrawer, handleApplyFilters }: FilterDrawerProps) => {
    
    const { t } = useTranslation();
    const { formState: { errors }, control, register, handleSubmit, reset } = useForm<FilterInputs>({ defaultValues: defaultValues });

    const onSubmit: SubmitHandler<FilterInputs> = (data) => {
        handleApplyFilters(data);
        toggleDrawer(false)();
    };

    const handleClear = () => {
        reset(); // Clear the form fields
        handleApplyFilters({ name: "", email: "", phone: "", companyTaxId: "", address: "", postalCode: "", status: "" }); // Clear filters
        // toggleDrawer(false)();
    };



    return (
        <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)} sx={styles.filterDrawer}  >
            {/* <form onSubmit={handleSubmit(onSubmit)}>
                <Box style={{ width: 300, padding: 16, position: "relative" }}>
                    <IconButton
                        onClick={toggleDrawer(false)}
                        sx={{ position: "absolute", top: 8, right: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <h3>Clients</h3>

                    <TextField
                        label="Name"
                        {...register("name")}
                        fullWidth
                        margin="normal"
                    />
                    <TextField
                        label="Phone"
                        {...register("phone")}
                        fullWidth
                        margin="normal"
                    />
                    <TextField
                        label="Email"
                        {...register("email")}
                        fullWidth
                        margin="normal"
                    />
                    <TextField
                        label="Company TaxId"
                        {...register("companyTaxId")}
                        fullWidth
                        margin="normal"
                    />

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "8px",
                            marginTop: "16px",
                        }}
                    >
                        <Button
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            onClick={handleClear}
                        >
                            Clear
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                        >
                            Filter
                        </Button>
                    </Box>
                </Box>
            </form> */}

            <Box component="form" sx={{ ...styles.formContainer, paddingLeft: "1rem", paddingRight: "1rem" }} onSubmit={handleSubmit(onSubmit)}>
                <Typography sx={styles.subHeading}>{t("clients")}</Typography>
                <IconButton
                    onClick={toggleDrawer(false)}
                    sx={{ position: "absolute", top: 8, right: 8 }}
                >
                    <CloseIcon />
                </IconButton>
                <Grid container spacing={2} xs={14} >
                <Grid item xs={6}>
                    <Controller
                        name="name"
                        control={control}
                        render={({ field }) => (
                            <InputField
                                {...field}
                                id="name"
                                label={t("name")}
                                placeholder={t("name")}
                                type="text"
                                showCross
                                fullWidth
                                size="small"
                                handleCrossClick={() => field.onChange("")}
                                error={!!errors.name?.message}
                                errorMessage={errors.name?.message}
                            />
                        )}
                    />

                </Grid>

                <Grid item xs={6}>
                    <Controller
                        name="phone"
                        control={control}
                        render={({ field }) => (
                            <InputField
                                {...field}
                                id="phone"
                                label={t("phone")}
                                placeholder={t("phone")}
                                type="text"
                                showCross
                                fullWidth
                                size="small"
                                handleCrossClick={() => field.onChange("")}
                                error={!!errors.phone?.message}
                                errorMessage={errors.phone?.message}
                            />
                        )}
                    />

                </Grid>

                <Grid item xs={6}>
                    <Controller
                        name="email"
                        control={control}
                        render={({ field }) => (
                            <InputField
                                {...field}
                                id="email"
                                label={t("email")}
                                placeholder={t("email")}
                                type="text"
                                showCross
                                fullWidth
                                size="small"
                                handleCrossClick={() => field.onChange("")}
                                error={!!errors.email?.message}
                                errorMessage={errors.email?.message}
                            />
                        )}
                    />

                </Grid>

                <Grid item  xs={6}>
                    <Controller
                        name="companyTaxId"
                        control={control}
                        render={({ field }) => (
                            <InputField
                                {...field}
                                id="companyTaxId"
                                label={t("companyTaxId")}
                                placeholder={t("companyTaxId")}
                                type="text"
                                showCross
                                fullWidth
                                size="small"
                                handleCrossClick={() => field.onChange("")}
                                error={!!errors.companyTaxId?.message}
                                errorMessage={errors.companyTaxId?.message}
                            />
                        )}
                    />

                </Grid>
                 <Grid item  xs={6}>
                    <Controller
                        name="postalCode"
                        control={control}
                        render={({ field }) => (
                            <InputField
                                {...field}
                                id="postalCode"
                                label={t("postalCode")}
                                placeholder={t("postalCode")}
                                type="text"
                                showCross
                                fullWidth
                                size="small"
                                handleCrossClick={() => field.onChange("")}
                                error={!!errors.postalCode?.message}
                                errorMessage={errors.postalCode?.message}
                            />
                        )}
                    />

                </Grid>
                 <Grid item  xs={6}>
                    <Controller
                        name="address"
                        control={control}
                        render={({ field }) => (
                            <InputField
                                {...field}
                                id="address"
                                label={t("address")}
                                placeholder={t("address")}
                                type="text"
                                showCross
                                fullWidth
                                size="small"
                                handleCrossClick={() => field.onChange("")}
                                error={!!errors.address?.message}
                                errorMessage={errors.address?.message}
                            />
                        )}
                    />

                </Grid>

                <Grid item  xs={6}>
                    <Controller
                        name="status"
                        control={control}
                        render={({ field }) => (
                            <CustomSelect
                                {...field}
                                id="status"
                                onChange={(e) => field.onChange(e.target.value)}
                                size="small"
                                fullWidth
                                placeholder="Status"
                                items={clientStatusList}
                                error={!!errors.status?.message}
                                errorMessage={errors.status?.message}
                                label="Status"
                            />
                         
                        )}
                    />

                </Grid>
                </Grid>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "8px",
                        marginTop: "16px",
                        paddingBottom: "3rem",
                    }}
                >
                    <Button
                        variant="outlined"
                        color="secondary"
                        fullWidth
                        onClick={handleClear}
                    >
                        {t("clear")}
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                    >
                        {t("filter")}
                    </Button>
                </Box>

            </Box>

        </Drawer>
    );
};

export default FilterDrawer;
